import React from "react";
//components
import FundoSite from "./components/FundoInicio/FundoSite";
import Sidebar from "./components/Siderbar/Siderbar"
import Player from "./components/Player/Player";
import Fim from "./components/Fim/Fim";
import Apoio from "./components/Apoio/Apoio";
//midias
import holos from "./components/campos/Videos/hologramas.mp4"
import flauta from "./components/campos/Videos/flautanovo.mp4"
import robo from "./components/campos/Videos/Baile dos Robôs.mp4"
import Almar from "./components/campos/Videos/Teaser Águas de El-Mar.mp4"


function App() {
  
  return (
    <div>
      <FundoSite/>
      <div >
        <Sidebar Titulo="Águas de Al-mar" subTitulo="">
        A obra apresenta uma sucessão de videoclipes das águas do 
        Rio Grande do Norte, Brasil: o mar, suas ondas, lagoas, nascentes
         e rios em um fluxo fílmico e sonoro como o fluxo das emoções da alma.
        </Sidebar>
        <Player src={Almar}></Player>

        <Sidebar Titulo="Baile dos robôs" subTitulo="2019 - 2022">
        Instalação interativa via comando de celulares.
         Um conjunto de mini robôs movimenta-se como um enxame.
          Apresentam aspectos luminosos e manifestações sonoras a partir
           do próprio movimento dos robôs 
        </Sidebar>
        <Player src={robo}></Player>

        <Sidebar Titulo="Flauta Mágica" subTitulo="2019 - 2022">
        Esta obra apresenta-se como uma interface para a maravilha.
         Instalação interativa onde uma flauta transversal permite criar
          arranjos simples com sons inspirados pelo espaço sideral.
           A interface  output é uma caixa mágica espelhada luminosa e
           sonora com saídas de fumaça.
        </Sidebar>
        <Player src={flauta}></Player>

        <Sidebar Titulo="Holograma 3D virtual Um sujeito e seus eus" subTitulo="2022 - 2023">
          Intervenção performance em um paredão goiano acompanhada de projeção de imagens com a participação do
          grupo Orquestra de Laptops da UnB. Propõe a invenção de um lugar utópico, multifacetado e em transformação.
          A trilha sonora é processada em tempo real a partir de frases sonoras que combinam-se e desdobram-se em constante
          mutação e hibridização. Os sons foram captados pelos artistas do projeto ibero-americano HOLOS,
          a partir de contextos sonoros oriundos do Brasil, Espanha, Uruguai, Colômbia e China.
        </Sidebar>
        <Player src={holos}></Player>
      </div>
      <Fim/>
      <Apoio/>
    </div>
  );
}

export default App;
/*




*/